import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

const textFiledStyles = {
  maxWidth: "600px",
  width: "100%",
  height: "36px",
  borderRaduis: "5px"
}

const inputStyles = {
  height: "100%",
  width: "100%"
}

const useStyles = makeStyles({
  inputStyles:{
    width: "100%",
    //border: "2px solid blue"
  },
  labelStyles: {
    alignSelf: "start",
    fontWeight: 500,
    fontSize: "1.125rem",
    marginBottom: 5,
  },
});

export default function InputOutlined({labelTitle, placeholderText, handleInputChange, name, type, handleValidate}){
  const classes = useStyles();

  const handleChange = (e) =>{
    handleInputChange([e.target.name], e.target.value);
  }

  return(
    <div className={classes.inputStyles}>
      {labelTitle && <p className={classes.labelStyles}>{labelTitle}</p>}
      <TextField onChange={handleChange} sx={textFiledStyles} name={name} type={type} variant="outlined" placeholder={placeholderText}
      InputProps={{sx:inputStyles}}/>
    </div>
  );
}

InputOutlined.defaultProps = {
  type: "text",
  labelTitle: "",
  placeholderText: "",
  handleInputChange: () => null,
};

InputOutlined.propTypes ={
  type: PropTypes.string,
  labelTitle: PropTypes.string,
  placeholderText: PropTypes.string,
  handleInputChange: PropTypes.func,
  name: PropTypes.string.isRequired,

}